import { Box, Button, Slide, Typography, useTheme } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  selectWallets,
  selectIsLoading,
  selectWalletsError,
} from "../../redux/state/walletsReduser/wallets.selectors";
 
import Loader from "../Loader/Loader";
import Error from "../Error/Error";
import handlePaymentClick from "./handlePaymentClick";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import {
  slideBoxStyles,
  typographyStyles,
  buttonStyles,
  noPaymentTextStyles,
  BoxStyles,
} from "./paymentButtons.styles";
function PaymentButtons({ isExiting, setIsExiting, createOrderData }) {
  const navigate = useNavigate();
  const wallets = useSelector(selectWallets);
  const isLoading = useSelector(selectIsLoading);
  const isError = useSelector(selectWalletsError);
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (createOrderData.price >= 10000) {
      enqueueSnackbar("Сумма заказа более 10 000₽. Доступна только оплата криптовалютой или у оператора.", { variant: "warning" });
    }
  }, [createOrderData.price, enqueueSnackbar]);

  const handleClick = useCallback(
    (walletId) => {
      handlePaymentClick(walletId, setIsExiting, createOrderData, navigate);
    },
    [setIsExiting, createOrderData, navigate]
  );

  const filteredWallets = createOrderData.price >= 10000
    ? wallets.filter(wallet => wallet.name !== "По карте + комиссия ")
    : wallets;

  return (
    <>
      {isLoading && <Loader />}
      {isError && <Error message="Ошибка при загрузке способов оплаты" />}
      <Slide direction="left" in={!isExiting} timeout={500}>
        <Box sx={slideBoxStyles}>
          <Typography variant="h6" sx={typographyStyles}>
            Выберите способ оплаты
          </Typography>

          {filteredWallets.length ? (
            <Box sx={BoxStyles}>
              {filteredWallets.map(({ _id, name }) => (
                <Button
                  key={_id}
                  variant="contained"
                  color="primary"
                  onClick={() => handleClick(_id)}
                  disabled={name === "С баланса" ? true : false} // Отключаем только кнопку "С баланса" для всех пользователей
                  sx={buttonStyles(theme)}
                >
                  {name === "С баланса" ? "С баланса (в разработке)" : name}
                </Button>
              ))}
            </Box>
          ) : (
            <Typography {...noPaymentTextStyles}>
              Нет доступных способов оплаты
            </Typography>
          )}
        </Box>
      </Slide>
    </>
  );
}

export default PaymentButtons;
